import { render, staticRenderFns } from "./HeaderOption.vue?vue&type=template&id=20ce1876&scoped=true"
import script from "./HeaderOption.vue?vue&type=script&lang=js"
export * from "./HeaderOption.vue?vue&type=script&lang=js"
import style0 from "./HeaderOption.vue?vue&type=style&index=0&id=20ce1876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ce1876",
  null
  
)

export default component.exports